import { CheckCircleFilled } from "@ant-design/icons"
import { Col, Select, Typography } from "antd"
import { doc, getDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { db } from "../../../firebase/config"

const { Text } = Typography

export default function SelectProductType({ productType, setProductType }) {
  const [options, setOptions] = useState([])
  const [loadingOptions, setLoadingOptions] = useState(true)

  useEffect(() => {
    const loadProductTypes = async () => {
      setLoadingOptions(true)
      try {
        const snap = await getDoc(doc(db, "settings", "productTypeList"))
        if (!snap.exists()) {
          throw new Error("Settings document 'productTypeList' does not exist.")
        }

        const arr = snap.data()?.productTypes ?? []
        if (!Array.isArray(arr) || arr.length === 0) {
          throw new Error("No product types found in settings.")
        }

        setOptions(arr.filter((s) => s !== "Pierīkošana").map((s) => ({ value: s, label: s })))
      } catch (err) {
        console.error("Failed to load product types:", err)
      } finally {
        setLoadingOptions(false)
      }
    }

    loadProductTypes()
  }, [])

  return (
    <>
      <Col span={10}>
        <Text>
          Product Type {productType ? <CheckCircleFilled style={{ color: "green" }} /> : ""}
        </Text>
      </Col>
      <Col span={14}>
        <Select
          style={{ width: "100%" }}
          loading={loadingOptions}
          placeholder="Select product type"
          options={options}
          value={productType || null}
          onChange={(value) => setProductType(value)}
          disabled={loadingOptions}
          showSearch
          optionFilterProp="label"
        />
      </Col>
    </>
  )
}
